import { useState } from "react";
import { comments } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function CommentWall() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="comments" className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          icon="ri-chat-quote-line"
          eyebrow="评论墙 · COMMENT WALL"
          title="把评论区当成线索的二次现场"
          desc="不少有效信息其实藏在评论区：有人补图、有人核对时间戳、也有人泼冷水。下面这些是当前讨论氛围比较浓的段落。"
          action={
            <span className="inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 text-xs text-foreground-700">
              <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulseDot" />
              评论实时滚动中
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-4 md:gap-5 md:grid-cols-2 lg:grid-cols-3">
          {comments.map((item, index) => {
            const isLiked = !!liked[item.id];
            return (
              <Reveal key={item.id} delay={index * 50}>
                <article className="flex h-full flex-col rounded-lg border border-background-300 bg-background-100 p-4 transition-colors duration-300 hover:border-primary-300 md:p-5">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                      {item.name.slice(0, 1)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <span className="truncate text-sm font-medium text-foreground-950">{item.name}</span>
                        {item.hot && (
                          <span className="flex items-center gap-0.5 rounded-md bg-accent-100 px-1.5 py-0.5 text-[10px] font-label text-accent-700">
                            <i className="ri-fire-fill text-[10px]" />
                            热评
                          </span>
                        )}
                      </div>
                      <span className="text-[11px] text-foreground-500">
                        {item.badge} · {item.time}
                      </span>
                    </div>
                  </div>

                  <p className="mt-3.5 flex-1 text-sm leading-relaxed text-foreground-800">
                    {item.text}
                  </p>

                  <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3.5">
                    <button
                      type="button"
                      onClick={() => toggleLike(item.id)}
                      className={`flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 text-xs transition-colors ${
                        isLiked
                          ? "bg-primary-100 text-primary-700"
                          : "text-foreground-600 hover:bg-background-200 hover:text-foreground-900"
                      }`}
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className={isLiked ? "ri-heart-fill" : "ri-heart-line"} />
                      </span>
                      {item.likes + (isLiked ? 1 : 0)}
                    </button>
                    <button
                      type="button"
                      className="flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 text-xs text-foreground-600 transition-colors hover:bg-background-200 hover:text-foreground-900"
                    >
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-reply-line" />
                      </span>
                      {item.replies} 回复
                    </button>
                    <span className="ml-auto flex h-7 w-7 items-center justify-center rounded-md text-foreground-400">
                      <i className="ri-more-2-fill" />
                    </span>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={60}>
          <div className="mt-6 flex flex-col items-center justify-between gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 px-5 py-4 text-center sm:flex-row sm:text-left">
            <p className="text-sm text-foreground-700">
              你的一句话可能就是别人缺的那块拼图。登录后可评论，本站不展示任何可识别个人信息。
            </p>
            <button
              type="button"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-secondary-200 px-5 py-2.5 text-sm font-label font-medium text-secondary-900 transition-colors hover:bg-secondary-300"
            >
              <i className="ri-chat-new-line text-base" />
              参与讨论
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}